export default "__VITE_ASSET__ec8126b8__"